exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sk-rotating-plane {\r\n    position: relative;\r\n    top: 50%;\r\n    width: 40px;\r\n    height: 40px;\r\n    margin: auto;\r\n    animation: sk-rotateplane 1.2s infinite ease-in-out;\r\n}\r\n\r\n@keyframes sk-rotateplane {\r\n    0% {\r\n        transform: perspective(120px) rotateX(0deg) rotateY(0deg);\r\n        -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg)\r\n    }\r\n    50% {\r\n        transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);\r\n        -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg)\r\n    }\r\n    100% {\r\n        transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);\r\n        -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);\r\n    }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/Empower360Plus/EmpowerWeb2.0/A4.Empower/A4.Empower/ClientApp/src/app/shared/spinner/spinkit-css/sk-rotating-plane.css
// module id = ../../../../../src/app/shared/spinner/spinkit-css/sk-rotating-plane.css
// module chunks = main